import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';

declare let google: any;

@Component({
  selector: 'ff-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss']
})
export class DonutChartComponent implements OnInit {

  /**
   * Prefix for the html elements id
   * @internal
   */
  @Input() idPrefix = '';

  /**
   * Data to display
   * Format: [text,value]
   * @internal
   */
  @Input() pieData: [string, number][] = [];

  /**
   * Inner text to display
   * @internal
   */
  @Input() title = '';

  /**
   * Unit of the total count (meters, units, seconds...)
   * @internal
   */
   @Input() totalUnit = '';


  /**
   * Position of the chart legend
   * @internal
   */
  @Input() legendPosition: 'none' | 'bottom' | 'top' | 'left' | 'right' | 'labeled' = 'bottom';

  /**
   * Style for the chart section tooltips
   * @internal
   */
  @Input() tooltipStyle: 'percentage' | 'value' | 'both' = 'both';

  @Output() selected = new EventEmitter();

  /**
   * Observable to trigger a chart resize
   * @internal
   */
  @Input() resize: Observable<boolean>;

  private resizerCallback: () => void = undefined;

  private pieChart: any = undefined;

  constructor() { }

  ngOnInit(): void {
    const _this = this;
    google.charts.load('current', { 'packages': ['corechart'] });
    google.charts.setOnLoadCallback(drawChart);

    function drawChart() {
      let fiveChartData = google.visualization.arrayToDataTable([['Task', 'Total'], ..._this.pieData]);

      let hoverChartOptions = {
        title: _this.title,
        titleTextStyle: {
          fontName: 'Lato',
          fontSize: 16,
          bold: true
        },
        pieHole: 0.8,
        pieSliceText: 'none',
        pieSliceTextStyle: {
          color: 'black',
        },
        legend: {
          position: _this.legendPosition,
          alignment: 'center',
          maxLines: 2,
        },
        tooltip: {
          text: _this.tooltipStyle,
          showColorCode: true
        },
        //Colors to be defined latter
        //colors: colors
      };

      function showTotal({ }) {
        const total = _this.pieData.reduce((total, row) => total + row[1], 0);
        const element = document.getElementById(`${_this.idPrefix}donutchart-overlay`);
        element.innerHTML = total == 0 ? '' : total.toFixed(0) + " " + _this.totalUnit;
      }

      function showGroupName({row}) {
        const element = document.getElementById(`${_this.idPrefix}donutchart-overlay`);
        element.innerHTML = fiveChartData.getValue(row, 0);
      }

      function selectHandler() {
        const [element] = _this.pieChart.getSelection()
        if (element){
          _this.selected.emit({value: fiveChartData.getValue(element.row, 0), row: element.row});
        }
      }

      if (!_this.pieChart) {
        _this.pieChart = new google.visualization.PieChart(document.getElementById(`${_this.idPrefix}donutchart-chart`));

        google.visualization.events.addListener(_this.pieChart, 'onmouseover', showGroupName);
        google.visualization.events.addListener(_this.pieChart, 'onmouseout', showTotal);
        google.visualization.events.addListener(_this.pieChart, 'select', selectHandler);

      }

      const resizer = document.getElementById(`${_this.idPrefix}resizer`);

      // remove any previous callbacks that may be using old data
      if (_this.resizerCallback)
        resizer.removeEventListener('click', _this.resizerCallback);

      // save reference for future use
      _this.resizerCallback = () => _this.pieChart.draw(fiveChartData, hoverChartOptions);
      resizer.addEventListener('click', _this.resizerCallback);

      resizer.click();
      showTotal({});
    }
  } //End ngOnInit


  ngAfterContentInit() {
    this.resize.subscribe(_ =>
      document
        .getElementById(`${this.idPrefix}resizer`)
        .click()
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.pieData) this.ngOnInit();
  }

}
